import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import * as fromUser from './store/user.reducer';
import { UserEffects } from './store/user.effects';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(fromUser.FEATURE_KEY, fromUser.reducer), EffectsModule.forFeature([UserEffects])],
})
export class UserDataAccessModule {}
